import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import definitionSaveButton from '../../images/Autocode/definitionSaveButton.svg';
import definitionCancelButton from '../../images/Autocode/definitionCancelButton.svg';

function GenericEditWithCancelSave({
  setEditing,
  initValue,
  saveInput,
  setInputText,
  isBuildEdit = false,
}) {
  const [editedName, setEditedName] = useState(initValue);
  const cancelEdit = () => {
    if(isBuildEdit){
      setEditing("cancel");
    } else {
      setEditing(false);
    }
  }
  return (
    <Fragment>
      <input
        ref={el => {
          setInputText(el);
        }}
        className="ac-rp-edit-input"
        type="text"
        value={editedName}
        onChange={e => setEditedName(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            if(editedName && editedName !== initValue) {
              saveInput(editedName);
            } else {
              setEditing(false);
            }
          } else if (e.key === 'Escape') {
            setEditing(false);
          }
        }}
        onBlur={() => {
          if(editedName && editedName !== initValue) {
            saveInput(editedName);
          } else {
            setEditing(false);
          }
        }}
      />
      <span className="pull-right ac-rp-edit-btns">
        <img
          className="ac-rp-save-btn"
          src={definitionSaveButton}
          alt="save"
          title="Save"
          onMouseDown={() => {
            if(editedName && editedName !== initValue) {
              saveInput(editedName);
            } else {
              setEditing(false);
            }
          }}
        />
        <img
          className="ac-rp-cancel-btn"
          src={definitionCancelButton}
          alt="cancel"
          title="Cancel"
          onMouseDown={() => {
            cancelEdit(false);
          }}
        />
      </span>
    </Fragment>
  );
}

GenericEditWithCancelSave.propTypes = {
  initValue: PropTypes.string,
  setInputText: PropTypes.func,
  saveInput: PropTypes.func,
  setEditing: PropTypes.func,
  isBuildEdit: PropTypes.bool,
}

export default GenericEditWithCancelSave

